import MyTextField from "../TextField";
import { FormControl, Select, MenuItem } from "@mui/material";
import MyTextLabel from "../InputLabel";
import MyMenuList from "../MenuList";

const FormScreenOne = ({ formData, formErrors, handleChange }) => {
  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.nameError}
      >
        <MyTextLabel shrink htmlFor={"name"}>
          Player ID
        </MyTextLabel>
        <MyTextField
          id={"name"}
          placeholder="Clare Jitu"
          value={formData.name}
          name="name"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.phoneError}
      >
        <MyTextLabel shrink htmlFor={"phone"}>
          Player Contact
        </MyTextLabel>
        <MyTextField
          id={"phone"}
          placeholder="08123456789"
          value={formData.phone}
          name="phone"
          onChange={handleChange}
        />
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.genderError}
      >
        <MyTextLabel shrink htmlFor={"gender"}>
          Gender
        </MyTextLabel>
        <Select
          id={"gender"}
          value={formData.gender}
          onChange={handleChange}
          input={<MyTextField />}
          name="gender"
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "Female";
            }
            return selected;
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          <MyMenuList value={""} disabled>
            Gender
          </MyMenuList>
          <MyMenuList value={"Female"} name={"lady"}>
            Female
          </MyMenuList>
          <MyMenuList value={"Male"} name={"gentleman"}>
            Male
          </MyMenuList>
          <MyMenuList value={"Others"} name={"abstain"}>
            Others
          </MyMenuList>
        </Select>
      </FormControl>
      <FormControl
        variant="standard"
        fullWidth
        required
        error={!!formErrors.emailError}
      >
        <MyTextLabel shrink htmlFor={"email"}>
          Player Email ID
        </MyTextLabel>
        <MyTextField
          id={"email"}
          placeholder="claraezejitu@gmail.com"
          value={formData.email}
          name="email"
          type="email"
          onChange={handleChange}
        />
      </FormControl>
    </>
  );
};

export default FormScreenOne;
